<div class="flex flex-row items-center justify-center">
    <h1 class="m-0">{{heading}}
        <!-- mobile view -->
        @if(dismissed){
            <div class="has-tooltip inline-block" (click)="undismiss()">
                <span class="tooltip -mt-10 p-1 w-max rounded bg-blue text-white text-base font-normal">Info einblenden</span>
               <ng-icon class="text-blue cursor-pointer mt-2" size="18" name="faCircleQuestion" />
            </div>
        }
    </h1>
</div>
@if(!dismissed){
<div class="mt-4 py-2 px-4 border rounded relative">
    <div id="flag" class="has-tooltip absolute cursor-pointer top-1 right-1" (click)="dismiss()">
        <span class="tooltip -mt-10 p-1 w-max rounded bg-blue text-white">Ausblenden</span>
        <ng-icon class="text-blue" size="18" name="faSolidXmark" />
    </div>

    <ng-content></ng-content>
</div>
}